import styled from "@emotion/styled";
import { css } from "@emotion/react";

export const HelperText = styled.span`
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1.66;
  letter-spacing: 0.03333em;
  text-align: left;
  margin: 3px 14px 0 14px;
  display: inline-block;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-25px);
  transition: all 250ms ease-in;
`;

export const InputWrapper = styled.div`
  margin-bottom: 16px;

  .fileInput {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    background: #ffffff;
    border: 1px solid #e6e6e7;
    border-radius: 8px;
    padding: 5px;
    margin-bottom: 30px;
    transition: all 250ms ease-in-out;
    button.select {
      background: #f2f2f3;
      padding: 7px 20px;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
    }
    ${props =>
      props.hasError
        ? css`
            border: 1px solid #d32f2f;
            button.select {
              color: #d32f2f;
            }
          `
        : css``};
  }
  .error-inputFile {
    margin-top: -25px;
    display: inherit;
    font-size: 12px;
    color: #d32f2f;
  }

  .MuiInputAdornment-root {
    p {
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      color: #000000;
    }
  }
  .MuiFormControlLabel-label {
    font-weight: 400;
    font-size: 13px;
    line-height: 22px;
    text-transform: capitalize;
    color: #0c0c0c;
  }
  legend.MuiFormLabel-root {
    margin-bottom: 6px;
    text-transform: capitalize;
    /*color: #000000;*/
    font-size: 14px;
  }
  .MuiFormLabel-root-MuiInputLabel-root:not(.Mui-focused) {
    span.optional {
      size: 12px;
      color: #808285;
    }
  }

  .MuiRadio-root:not(.Mui-checked) {
    color: #e5e5ea;
  }
  .MuiCheckbox-root:not(.Mui-checked) {
    color: #e5e5ea;
  }

  .datePicker {
    ${props =>
      props.hasError
        ? css`
            .MuiOutlinedInput-notchedOutline {
              border: 1px solid #d32f2f;
            }
            .MuiInputLabel-root,
            .MuiSvgIcon-root {
              color: #d32f2f;
              path {
                fill: #d32f2f;
              }
            }
          `
        : css``};
  }

  ${props =>
    props.hasLabel
      ? css``
      : css`
          .MuiOutlinedInput-notchedOutline {
            top: 0;
          }
          legend {
            display: none;
          }
        `};

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }
`;

export const ScoreButtonsWrapper = styled.div`
  input {
    display: none;
  }
  .scoreWrapper {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(45px, auto));
    height: 45px;

    @media screen and (min-width: 900px) and (max-width: 1041px) {
      grid-auto-rows: 45px;
      margin-bottom: 50px;
    }
  }
  label {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border: 1px solid #e6e6e7;
    border-radius: 8px;
    color: #000000;
    cursor: pointer;
    transition: all 50ms ease-in-out;
    margin-right: 10px;
    &:hover {
    }
    &.error {
      border-color: #d32f2f;
      color: #d32f2f;
    }
    &.selected {
      border-bottom: 2px solid #17479e;
    }
    span {
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      text-align: center;
      text-transform: lowercase;
    }
    @media screen and (min-width: 900px) and (max-width: 1041px) {
      margin-bottom: 5px;
    }
  }

  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      ".scoreWrapper": {
        gridTemplateColumns: "repeat(auto-fit, minmax(45px, 50px))",
      },
    },
  })}
`;

export const FormSuccessWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .title {
    font-weight: 700;
    font-size: 16px;
    line-height: 32px;
    color: #000000;
    margin-bottom: 5px;
  }
  .subtitle {
    font-weight: 400;
    font-size: 14px;
    line-height: 32px;
    color: #808285;
  }
  .tracking_key {
    margin-top: 40px;
    padding: 8px 16px;
    background: #ffffff;
    border: 1px solid #e6e6e7;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 130px;
    .key {
      font-weight: 400;
      font-size: 14px;
      text-transform: capitalize;
      color: #000000;
    }
    .numKey {
      font-weight: 400;
      font-size: 22px;
      letter-spacing: 0.1em;
      color: #17479e;
    }
  }
`;
